import React from "react";
import {Button, Row, Col, Glyphicon, FormControl} from "react-bootstrap";
import Component from "../../components/AscComponent";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import BusinessCalendarModal from "./BusinessCalendarModal";
import BusinessCalendarIrrBatchModal from "./BusinessCalendarIrrBatchModal";
import BusinessCalendarNumberSettingInfoDiagram from '../../components/Modal/BusinessCalendarNumberSettingInfoDiagram';
import Type from "./Type.json";
import * as GlobalConst from "../../components/AscConstants";
import moment from 'moment';
import 'moment/locale/ja';
moment.locale('ja');

export default class BusinessCalenadr extends Component {
    constructor(props) {
        super(props);

        this.day_string = {
            [Type.DAY.SUN]: this.props.langText.Body.Sunday,
            [Type.DAY.MON]: this.props.langText.Body.Monday,
            [Type.DAY.TUE]: this.props.langText.Body.Tuesday,
            [Type.DAY.WED]: this.props.langText.Body.Wednesday,
            [Type.DAY.THU]: this.props.langText.Body.Thursday,
            [Type.DAY.FRI]: this.props.langText.Body.Friday,
            [Type.DAY.SAT]: this.props.langText.Body.Saturday,
            [Type.DAY.HOLI]: this.props.langText.Body.Holiday,
            // [Type.DAY.B_HOLI]: this.props.langText.Body.DayBeforeHoliday,
        };

        this.action_string = {
            [Type.ACTION.INBOUND]: this.props.langText.Body.Inbound,
            [Type.ACTION.BUSY]: this.props.langText.Body.Busy,
            [Type.ACTION.TRANSFER]: this.props.langText.Body.ExternalTransfer,
            [Type.ACTION.VOICE]: this.props.langText.Body.PlayVoice,
            [Type.ACTION.SCRIPT]: this.props.langText.Body.Script,
            [Type.ACTION.ANSWERING_MACHINE]: this.props.langText.Body.AnsweringMachine,
            [Type.ACTION.AUTO_RECEPTION]: this.props.langText.Body.AutoReception
        };

        this.business_string = {
            [Type.BUSINESS.START]: this.props.langText.Body.BusinessDay,
            [Type.BUSINESS.END]: this.props.langText.Body.DayOff
        };

        this.irr_business_string = {
            [Type.BUSINESS.START]: this.props.langText.Body.BusinessDay,
            [Type.BUSINESS.END]: this.props.langText.Body.DayOff,
            [Type.BUSINESS.DEL]: this.props.langText.Body.Delete
        };

        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            filtered: [],
            pages: null,
            loading: false,

            // modal item
            show: false,
            showRender: false,
            modalType: null,
            calendarUsingData: [],
            calendarValidationFlag: true,
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: "",
            confirmValue: "",

            // 番号設定構成図用
            showResourceMap: false,
            resourceMapLoading: false,
            resourceMapData: null
        };

        // 遅延アンマウント用タイマー
        this.hideTimer = null;
    }

    componentDidMount = async() => {
        // 追加確認ポップアップ表示の対象画面であるか
        try {
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        // show が true -> false に変化: 1秒後にアンマウント
        if (prevState.show && !this.state.show) {
            if (this.hideTimer) clearTimeout(this.hideTimer);
            this.hideTimer = setTimeout(() => {
                this.setState({ showRender: false });
            }, 100);
        }

        // show が false -> true に変化: 即座に表示継続フラグON
        if (!prevState.show && this.state.show) {
            if (this.hideTimer) clearTimeout(this.hideTimer);
            if (!this.state.showRender) {
                this.setState({ showRender: true });
            }
        }
    }

    componentWillUnmount = () => {
        if (this.hideTimer) clearTimeout(this.hideTimer);
    }

    getColumnsData = () => {
        let elem = [];
        let day_column = this.getDayColumns();

        elem.push({
            Header: this.props.langText.Body.Id,
            accessor: "id",
            width: this.props.boardWidth.id,
            filterable: false
        });

        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            elem.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: "cm12_companies.company_name",
                Filter: () => <FormControl 
                    placeholder={this.props.langText.Body.ForwardMatch} 
                    onChange={e => this.onFilterChange(e.target.value, "cm12_companies.company_name")}/>
            });
        }

        elem.push({
            Header: this.props.langText.Body.BusinessCalendar,
            accessor: "business_calendar_name",
            Filter: () => <FormControl 
                placeholder={this.props.langText.Body.ForwardMatch} 
                onChange={e => this.onFilterChange(e.target.value, "business_calendar_name")}/>
        },
        ...day_column,
        {
            Header: this.props.langText.Body.Control,
            width: this.props.boardWidth.smedium,
            Cell: data => {
                let elem = [];

                if (this.props.currentPermission.edit) {
                    elem.push(
                        <Button
                            key="update"
                            bsSize="xsmall"
                            onClick={this.modalShow("update", data.row._original)}
                            className="control-button">
                            <Glyphicon glyph="pencil"/>
                        </Button>
                    );
                } else {
                    elem.push(
                        <Button
                            key="read"
                            bsSize="xsmall"
                            onClick={this.modalShow("read", data.row._original)}
                            className="control-button">
                            <Glyphicon glyph="eye-open"/>
                        </Button>
                    );
                }

                if (this.props.currentPermission.create) {
                    elem.push(
                        <Button
                            key="copy"
                            bsSize="xsmall"
                            onClick={this.modalShow("copy", data.row._original)}
                            className="control-button">
                            <Glyphicon glyph="copy"/>
                        </Button>
                    );
                }

                if (this.props.currentPermission.delete) {
                    elem.push(
                        <Button
                            key="delete"
                            bsSize="xsmall"
                            onClick={this.modalShow("delete", data.row._original)}
                            className="control-button">
                            <Glyphicon glyph="minus"/>
                        </Button>
                    );
                }

                if (this.hasRequiredNumberSettingReadAuthority()) {
                    elem.push(
                        <Button
                            key="info"
                            bsSize="xsmall"
                            onClick={(event) => this.showNumberSettingInfoDiagram(event, data.row._original)}
                            className="control-button">
                            <Glyphicon glyph="info-sign"/>
                        </Button>
                    );
                }

                return(
                    <Row className="text-center">
                        {elem}
                    </Row>
                )
            },
            sortable: false,
            filterable: false
        });

        return elem;
    }

    getDayColumns = () => {
        let day_colums = [];

        for (let day in this.day_string) {
            day_colums.push({
                Header: this.day_string[day],
                accessor: "cm32_business_calendar_details",
                width: this.props.boardWidth.week,
                Cell: data => {
                    const day_info = data.row.cm32_business_calendar_details.find(row => row.day_of_the_week === day);

                    if (day_info) {
                        const action = day_info.type === Type.BUSINESS.START ? day_info.business_hour_action_flag : day_info.non_business_hour_action_flag;
                        if (this.action_string[action]) return this.action_string[action];
                    }

                    return "---";
                },
                sortable: false,
                filterable: false
            });
        }

        return day_colums;
    }
    modalShow = (modalType, param) => async event => {
        event.preventDefault();
        this.blockUI();

        try {
            if (param && param.id) param = (await this.getModal(param.id)).data[0];

            //複製モーダルには過去のイレギュラーを表示しない
            let business_calendar_name = param? param.business_calendar_name : "";
            let cm33_business_calendar_irregular_infos = param ? param.cm33_business_calendar_irregular_infos: [];
            
            if (modalType == "copy"){
                business_calendar_name = "";
                cm33_business_calendar_irregular_infos = param.cm33_business_calendar_irregular_infos_future;
            }

            let calendarUsingData = [];
            let calendarValidationFlag = true;

            //使用中のカレンダーかを確認して、使用中の場合カレンダー削除不可バリデーション追加・使用している箇所表示
            if(modalType === "delete"){
                let checkCalendarUsing = await this.ascAxios("post", `${this.reactContainerPath}/checkCalendarUsing`, {calendar_id : param.id});
                let checkcalendarUsingData = checkCalendarUsing.data;
                let calendarUsedFlag = checkcalendarUsingData.some(element => element.length > 0);
                
                if(calendarUsedFlag){
                    calendarValidationFlag = false;
                    calendarUsingData = [];
                    if(checkcalendarUsingData[0]){
                        checkcalendarUsingData[0].forEach(element => {
                            calendarUsingData.push(
                                element.memo 
                                ? this.sprintf(
                                    this.props.langText.Message.calendarDeleteError,
                                    element.memo + " (" + element.display_number + ")")
                                : this.sprintf(
                                    this.props.langText.Message.calendarDeleteError,
                                    element.display_number)
                            );
                        });
                    }
                    calendarUsingData = calendarUsingData.map(elem =>{
                        return <div>{elem}</div>
                    });
                }
            };

            let company_id = param ? param.cm12_companies.id : this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem) ? "" : this.props.userInfo.company_id;

            this.setState({
                id: param ? param.id : "",
                business_calendar_name,
                company_id,
                company_name: param ? param.cm12_companies.company_name : this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem) ? "" : this.props.userInfo.company_name,
                cm32_business_calendar_details: param ? param.cm32_business_calendar_details : [],
                cm33_business_calendar_irregular_infos,
                calendarUsingData,
                calendarValidationFlag,
                modalType,
                show: true,
                showRender: true,
                showConfirm: false,
                confirmMemo: "",
                confirmValue: "",
                isSetShowAddingConfirmationPopup:
                    company_id !== ""
                        ? await this.getIsShowAddingConfirmationPopup(company_id)
                        : false
            });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
            this.reactTableRefresh();
        }
    }

    hasRequiredNumberSettingReadAuthority = () => {
        try {
            const permissionList = (this.props.userInfo && this.props.userInfo.permission_json_data) ? this.props.userInfo.permission_json_data : [];
            const p = permissionList.find(row => row.controller_id === "ExternalNumber");
            return !!(p && p.read);
        } catch (e) {
            return false;
        }
    }

    showNumberSettingInfoDiagram = async (event, rowData) => {
        try {
            event.preventDefault();
            this.setState({
                showResourceMap: true,
                resourceMapLoading: true,
                resourceMapData: null
            });
            const result = await this.ascAxios(
                "post",
                `${this.reactContainerPath}/getLinkedExternalNumbersForNumberSettingInfoDiagram`,
                { business_calendar_id: rowData.id }
            );
            const resourceMapData = {
                businessCalendarId: rowData.id,
                businessCalendarName: rowData.business_calendar_name,
                companyName: this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)
                    ? rowData.cm12_companies.company_name
                    : this.props.userInfo.company_name,
                externalNumbers: result.data.externalNumbers || []
            };
            this.setState({
                resourceMapData,
                resourceMapLoading: false
            });
        } catch (err) {
            this.setState({ showResourceMap: false, resourceMapLoading: false });
            this.showErrorObjectMesssage(err);
        }
    }

    getModal = (id) => {
        return this.ascAxios("post", `${this.reactContainerPath}/modal`, {id});
    }

    onClickHandle = (state) => {
        if (
            (
                this.state.modalType === "insert"
                || this.state.modalType === "copy"
                || this.state.modalType === "update"
                || this.state.modalType === "delete"
            )
            &&
            (
                !this.isTargetShowAddingConfirmationPopup ||
                !this.state.isSetShowAddingConfirmationPopup
            )
        ) {
            // 追加確認ポップアップ表示設定がOFFである場合、
            // 通常の確認ポップアップを表示
            if (!window.confirm(`${this.createPopupMessage(
                this.props.langText.Body.BusinessCalendar,
                state.business_calendar_name,
                this.state.modalType
            )}`)) {
                return;
            }
        }

        switch(this.state.modalType) {
            case "insert":
            case "copy":
                this.blockUI();
                this.ascAxios("post", `${this.reactContainerPath}/insert`, {
                    company_id: state.company_id,
                    business_calendar_name: state.business_calendar_name,
                    cm32_business_calendar_details: state.cm32_business_calendar_details,
                    cm33_business_calendar_irregular_infos: state.cm33_business_calendar_irregular_infos,
                    confirmMemo: this.state.confirmMemo
                })
                .then(res => {
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh();
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                    if (err.response.data.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({ show: false });
                    }
                });
                break;
            case "update":
                this.blockUI();
                this.ascAxios("post", `${this.reactContainerPath}/update`, {
                    id: state.id,
                    company_id: state.company_id,
                    business_calendar_name: state.business_calendar_name,
                    cm32_business_calendar_details: state.cm32_business_calendar_details,
                    cm33_business_calendar_irregular_infos: state.cm33_business_calendar_irregular_infos,
                    confirmMemo: this.state.confirmMemo,
                    isSetShowAddingConfirmationPopup: this.state.isSetShowAddingConfirmationPopup
                })
                .then(res => {
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.reactTableRefresh();
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                    if (err.response.data.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({ show: false });
                    }
                });
                break;
            case "delete":
                this.blockUI();
                this.ascAxios("post", `${this.reactContainerPath}/delete`, {
                    id: state.id,
                    confirmMemo: this.state.confirmMemo,
                    isSetShowAddingConfirmationPopup: this.state.isSetShowAddingConfirmationPopup,
                    company_id: state.company_id, // データ変更時メール送信処理で使用
                    business_calendar_name: state.business_calendar_name, // データ変更時メール送信処理で使用
                })
                .then(res => {
                    alert(this.props.langText.Message.DataDeleteSuccess);
                    this.reactTableRefresh();
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                    if (err.response.data.code === "SendMailWhenDataChangedError") {
                        this.reactTableRefresh();
                        this.setState({ show: false });
                    }
                });
                break;
            default:
                break;
        }
        
        this.setState({
            show: false,
            showConfirm: false  // 追加確認ポップアップも同時に閉じる
        });
    }

    /**
     * modalTypeにより分岐させる
     */
    getModalBranch = () => {
        // showRender が false の間はモーダルを描画しない（1秒遅延の後にfalseへ）
        if (!this.state.showRender) return null;
        switch (this.state.modalType) {
            case "insert":
            case "read":
            case "copy":
            case "update":
            case "delete":
                return (
                    <BusinessCalendarModal
                        state={this.state}
                        propSetState={this.propSetState}
                        reactContainerPath={this.reactContainerPath}
                        currentPermission={this.props.currentPermission}
                        dayString={this.day_string}
                        actionString={this.action_string}
                        businessString={this.business_string}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick={this.onClickHandle}
                        onClickConfirm={this.onClickConfirm}
                        onTextChange_Limit={this.onTextChange_Limit}
                        isTargetShowAddingConfirmationPopup = {this.isTargetShowAddingConfirmationPopup}
                    />
                );
            case "irregularBatchSetting":
                return (
                    <BusinessCalendarIrrBatchModal
                        state={this.state}
                        propSetState={this.propSetState}
                        reactContainerPath={this.reactContainerPath}
                        currentPermission={this.props.currentPermission}
                        dayString={this.day_string}
                        actionString={this.action_string}
                        businessString={this.irr_business_string}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick={this.onClickHandle}
                        onClickConfirm={this.onClickConfirm}
                        onTextChange_Limit={this.onTextChange_Limit}
                        isTargetShowAddingConfirmationPopup = {this.isTargetShowAddingConfirmationPopup}
                    />
                );
            default:
                break;
        }
    }

    render() {
        return (
            <div className="BusinessCalendar">
                <Row>
                    <Col xs={12} md={12}>
                        {this.props.currentPermission.create &&
                            <Button
                                className="table-button"
                                id="calendar-inster-btn"
                                bsStyle="default"
                                bsSize="sm"
                                onClick={this.modalShow("insert")}
                                value="insert">
                                {this.props.langText.Body.InsertTitle}
                            </Button>                 
                        }
                        {this.props.currentPermission.edit &&
                            <Button
                                className="table-button"
                                id="board_irregular-batch-button"
                                bsStyle="default"
                                bsSize="sm"
                                onClick={this.modalShow("irregularBatchSetting")}>
                                {this.props.langText.Body.IrregularBatchSetting}
                            </Button>
                        }
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual="manual"
                            columns={this.state.columns}
                            data={this.state.data}
                            pages={this.state.pages}
                            loading={this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            filterable={true}
                            previousText={this.props.langText.Table.PreviousText}
                            nextText={this.props.langText.Table.NextText}
                            loadingText={this.props.langText.Table.LoadingText}
                            noDataText={this.props.langText.Table.NoDataText}
                            rowsText={this.props.langText.Table.RowsText}/>
                    </Col>
                </Row>
                {this.getModalBranch()}
                <BusinessCalendarNumberSettingInfoDiagram
                    state={this.state}
                    langText={this.props.langText}
                    propSetState={this.propSetState}
                    ascAxios={this.ascAxios}
                    getScopeGreaterEqual={this.getScopeGreaterEqual}
                    userInfo={this.props.userInfo}
                    boardWidth={this.props.boardWidth}
                    tableClass="business-calendar-resource-map-table"
                    connectionLineClass="business-calendar-connection-lines"
                />
            </div>
        );
    }
}